import React, { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { isRTLLangue } from '../../common/utils';
import { CodeResult } from '../../components/CodeResult/CodeResult';
import LanguageSelect from '../../components/LanguageSelect/LanguageSelect';
import Menu from '../../components/Menu/Menu';
import { Preview } from '../../components/Preview/Preview';
import WidgetForm from '../../components/WidgetForm/WidgetForm';
import useOnloadActions from '../../hooks/useOnloadActions';
import getI18N from '../../lib/i18n';
import { setField } from '../../store/form';
import {
    isCodeShownSelector,
    languageSelector,
    widgetTypeSelector,
} from '../../store/form/selectors';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import styles from './Home.module.scss';

export const Home = (): JSX.Element => {
    useOnloadActions();

    const searchParams = useSearchParams();
    const dispatch = useAppDispatch();
    const setParam = searchParams[1];
    const language = useAppSelector(languageSelector);
    const isRTL = isRTLLangue(language);
    const setMenuActive = useCallback(
        (value: string) => {
            dispatch(setField({ name: 'type', value }));
            setParam({ type: value });
        },
        [dispatch, setParam]
    );
    const type = useAppSelector(widgetTypeSelector);
    const isCodeShown = useAppSelector(isCodeShownSelector);
    const i18n = getI18N();
    return (
        <div dir={isRTL ? 'rtl' : 'ltr'}>
            <section className={styles.homepage}>
                <div className={styles['layout-container']}>
                    <div className={styles['preview-zone']}>
                        <Preview />
                    </div>
                    <div className={styles['menu-zone']}>
                        <div className={styles['header-row']}>
                            <h1 className={styles['menu-header']}>{i18n('Генератор виджета')}</h1>
                            <LanguageSelect />
                        </div>
                        <Menu active={type} setActive={setMenuActive} />
                    </div>
                    <div className={styles['form-zone']}>
                        {isCodeShown && <CodeResult />}
                        {!isCodeShown && <WidgetForm />}
                    </div>
                </div>
            </section>
        </div>
    );
};
